import React, { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';

export interface FormContextContextProps {
	setFormMethods: (data: UseFormReturn) => void;
	formMethods: UseFormReturn;
}

const FormContext = React.createContext<FormContextContextProps>({
	setFormMethods: {},
	formMethods: {},
} as FormContextContextProps);

export function FormContextProvider(props) {
	const [formMethods, setFormMethods] = useState<UseFormReturn>(
		{} as UseFormReturn,
	);

	return (
		<FormContext.Provider value={{ ...props, formMethods, setFormMethods }}>
			{props.children}
		</FormContext.Provider>
	);
}

export const useFormContext = () => React.useContext(FormContext);
